const jobbet = [
    {
        'q': 'Jag trivs med mitt arbetsinnehåll',
        'a': 0
    },
    {
        'q': 'Jag har tydliga mål',
        'a': 0,
    },
    {
        'q': 'Jag upplever att andras krav på mig är rimliga',
        'a': 0,
    },
    {
        'q': 'Jag har en bra relation med min chef',
        'a': 0,
    },
    {
        'q': 'Samarbete med kollegor fungerar bra',
        'a': 0,
    },
    {
        'q': 'Jag får den feedback som jag behöver',
        'a': 0,
    },
    {
        'q': 'Jag trivs med den sociala arbetsmiljön',
        'a': 0,
    },
    {
        'q': 'Jag är nöjd med min egen arbetsinsats',
        'a': 0,
    },
    {
        'q': 'Jag är nöjd med löner och förmåner',
        'a': 0,
    },
    {
        'q': 'Mina arbetstider fungerar bra för mig',
        'a': 0,
    },
    {
        'q': 'Jag är nöjd med den fysiska arbetsmiljön',
        'a': 0,
    },
    {
        'q': 'Jag får den koncentration jag behöver',
        'a': 0,
    },
    {
        'q': 'Jag har tid för egen reflektion och planering',
        'a': 0,
    },
    {
        'q': 'Jag kan hantera eventuell stress på ett bra sätt',
        'a': 0,
    },
    {
        'q': 'Jag får hjälp och stöd när jag behöver',
        'a': 0,
    },
    {
        'q': 'Jag känner mig trygg på jobbet',
        'a': 0,
    },
    {
        'q': 'Jag har bra rutiner',
        'a': 0,
    },
    {
        'q': 'Jag är nöjd med hur möten fungerar',
        'a': 0,
    },
];

export default jobbet;